import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class CalculationDataService {

    // get and set
    private _burnarea: number;
    private _burnarea1: number;
    private _burnarea2a: number;
    private _burnarea2b: number;
    private _burnarea3: number;
    private _burnarea4: number;
    private _burnareaT: number;
    private _burnarea1T: number;
    private _burnarea2aT: number;
    private _burnarea2bT: number;
    private _burnarea3T: number;
    private _burnarea4T: number;
    private _parkland: number;

    constructor() {
        this._burnarea = 0;
        this._burnarea1 = 0;
        this._burnarea2a = 0;
        this._burnarea2b = 0;
        this._burnarea3 = 0;


        this._burnareaT = 0;
        this._burnarea1T = 0;
        this._burnarea2aT = 0;
        this._burnarea2bT = 0;
        this._burnarea3T = 0;
        this._burnarea4T = 0;

    }


    get burnarea(): number {
        return this._burnarea;
    }

    set burnarea(value: number) {
        this._burnarea = value;
    }


    get burnarea1(): number {
        return this._burnarea1;
    }

    set burnarea1(value: number) {
        this._burnarea1 = value;
    }

    get burnarea2a(): number {
        return this._burnarea2a;
    }

    set burnarea2a(value: number) {
        this._burnarea2a = value;
    }

    get burnarea2b(): number {
        return this._burnarea2b;
    }

    set burnarea2b(value: number) {
        this._burnarea2b = value;
    }


    get burnarea3(): number {
        return this._burnarea3;
    }

    set burnarea3(value: number) {
        this._burnarea3 = value;
    }


    get burnarea4(): number {
        return this._burnarea4;
    }

    set burnarea4(value: number) {
        this._burnarea4 = value;
    }


    get burnareaT(): number {
        return this._burnareaT;
    }

    set burnareaT(value: number) {
        this._burnareaT = value;
    }


    get burnarea1T(): number {
        return this._burnarea1T;
    }

    set burnarea1T(value: number) {
        this._burnarea1T = value;
    }


    get burnarea2aT(): number {
        return this._burnarea2aT;
    }

    set burnarea2aT(value: number) {
        this._burnarea2aT = value;
    }


    get burnarea2bT(): number {
        return this._burnarea2bT;
    }

    set burnarea2bT(value: number) {
        this._burnarea2bT = value;
    }


    get burnarea3T(): number {
        return this._burnarea3T;
    }

    set burnarea3T(value: number) {
        this._burnarea3T = value;
    }


    get burnarea4T(): number {
        return this._burnarea4T;
    }

    set burnarea4T(value: number) {
        this._burnarea4T = value;
    }

    get parkland(): number {
        return this._parkland;
    }

    set parkland(value: number) {
        this._parkland = value;
    }

    public clear() {
        this._burnarea = 0;
        this._burnarea1 = 0;
        this._burnarea2a = 0;
        this._burnarea2b = 0;
        this._burnarea3 = 0;
        this._burnarea4 = 0;

        this._burnareaT = 0;
        this._burnarea1T = 0;
        this._burnarea2aT = 0;
        this._burnarea2bT = 0;
        this._burnarea3T = 0;
        this._burnarea4T = 0;
        this._parkland = 0;
    }
}
